import { useContext } from 'react';
import { VisibleContext, SetVisibleContext } from './Provider';

export const useModalVisible = () => useContext(VisibleContext);
export const useSetModalVisible = () => useContext(SetVisibleContext);
